import { render, staticRenderFns } from "./StuJap_Collect.vue?vue&type=template&id=0e4a8c15&scoped=true"
import script from "./StuJap_Collect.vue?vue&type=script&lang=js"
export * from "./StuJap_Collect.vue?vue&type=script&lang=js"
import style0 from "./StuJap_Collect.vue?vue&type=style&index=0&id=0e4a8c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a8c15",
  null
  
)

export default component.exports